<template>
	<section class="newsletter">
		<div class="row align-center">
			<div class="columns column12">
				<h2>{{ header }}</h2>
				<div v-parse-links v-html="content" />

				<!-- Begin Mailchimp Signup Form -->
				<div id="mc_embed_signup" class="mc-column">
					<form
						id="mc-embedded-subscribe-form"
						action="https://metzlrhouse.us9.list-manage.com/subscribe/post?u=0fac175f612dd137a9462e91a&id=4ec5894750&f_id=00afc2e1f0"
						method="post"
						name="mc-embedded-subscribe-form"
						class="validate newsletter"
						target="_blank"
						novalidate
					>
						<input
							id="mce-EMAIL"
							type="email"
							value=""
							name="EMAIL"
							class="required email"
							:placeholder="$t('formEmail')"
						/>
						<input
							id="mc-embedded-subscribe"
							type="submit"
							name="subscribe"
							class="button"
							:value="button"
						/>
						<div id="mce-responses" class="clear">
							<div id="mce-error-response" class="response" style="display: none" />
							<div id="mce-success-response" class="response" style="display: none" />
						</div>
						<!-- real people should not fill this in - do not remove this or risk bot signups-->
						<div style="position: absolute; left: -5000px" aria-hidden="true">
							<input type="text" name="b\_0fac175f612dd137a9462e91a\_4ec5894750" tabindex="-1" value="" />
						</div>
					</form>
				</div>
				<!-- end Mailchimp Signup Form -->
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
section.newsletter {
	padding: 50px 0 0;
	border-top: 1px solid var(--contentblock-background-color);
	border-bottom: none;

	p {
		max-width: 600px;
		margin: 0 auto 20px;
	}

	input {
		appearance: none;
	}

	input:not(.button) {
		color: var(--body-color);
		border: none;
		width: 280px;
		padding: 0 20px;
		line-height: 49px;
		outline: none !important;
	}

	.button {
		border: none;
		margin: 0;
		cursor: pointer;
		outline: none;
	}
}

.package-subpage section.newsletter {
	padding: 50px 0;
}

form.newsletter {
	background: #fff;
	display: inline-block;
	margin: 20px auto 50px;
}

@media (max-width: 680px) {
	.newsletter input {
		width: 100%;
		text-align: center;
	}
}
</style>
